import { Link, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import moment from "moment";
import { useParams } from "react-router-dom";

import { useMaintenanceByProductIdQuery } from "api/public/project/maintenance/maintenance.api";

import SidebarSection from "../../SidebarSection";

const AmSection = () => {
  const { id } = useParams();
  const { data: maintenances } = useMaintenanceByProductIdQuery(
    id ?? skipToken,
    {
      selectFromResult: (result) => {
        return {
          ...result,
          data: result.data?.filter((am) => am.status === "Approved") || [],
        };
      },
    },
  );

  if (!maintenances.length) return;

  return (
    <SidebarSection title="Maintenance Releases">
      {maintenances.map(({ maintenance_id, completion_date, title }) => {
        const formattedDate = moment.utc(completion_date).format("MM/DD/YYYY");

        return (
          <Link
            key={maintenance_id}
            href={`/products/${id}/assurancemaintenance/${maintenance_id}`}
            color="inherit"
          >
            <Typography variant="body1">
              {`${title} ${completion_date && formattedDate}`}
            </Typography>
          </Link>
        );
      })}
    </SidebarSection>
  );
};

export default AmSection;
